export interface QuestionOption {
  id: number;
  label: string;
}

export const EXTENDED_CLASS_ID = 2;
export const DEFAULT_CLASS_ID = 3;
export const DATA_QUALITY_CLASS_ID = 5;
export const SEGMENTATION_CLASS_ID = 6;
export const TRAINING_DATA_CLASS_ID = 7;
export const MICROSURVEY_CLASS_ID = 8;

export const QUESTION_CLASS_OPTIONS: QuestionOption[] = [
  { id: EXTENDED_CLASS_ID, label: 'Extended' },
  { id: DEFAULT_CLASS_ID, label: 'Custom' },
  { id: DATA_QUALITY_CLASS_ID, label: 'Data Quality' },
  { id: SEGMENTATION_CLASS_ID, label: 'Segmentation' },
  { id: TRAINING_DATA_CLASS_ID, label: 'Training Data' },
  { id: MICROSURVEY_CLASS_ID, label: 'Microsurvey' },
];

export const SINGLE_PUNCH_TYPE_ID = 1;
export const MULTI_PUNCH_TYPE_ID = 3;
export const RANGE_TYPE_ID = 4;
export const INPUT_TYPE_ID = 5;
export const OPEN_ENDED_TYPE_ID = 7;

export const QUESTION_TYPE_OPTIONS: QuestionOption[] = [
  { id: SINGLE_PUNCH_TYPE_ID, label: 'Single Punch' },
  { id: MULTI_PUNCH_TYPE_ID, label: 'Multi Punch' },
  { id: RANGE_TYPE_ID, label: 'Range' },
  { id: INPUT_TYPE_ID, label: 'Input' },
  { id: OPEN_ENDED_TYPE_ID, label: 'Open Ended' },
];

export const ALPHA_NUMERIC_ANSWER_ORDER_ID = 1;
export const RANDOM_ANSWER_ORDER_ID = 2;
export const CUSTOM_ANSWER_ORDER_ID = 3;

export const QUESTION_ANSWER_ORDER_OPTIONS: QuestionOption[] = [
  { id: ALPHA_NUMERIC_ANSWER_ORDER_ID, label: 'Alpha/Numeric' },
  { id: RANDOM_ANSWER_ORDER_ID, label: 'Random' },
  { id: CUSTOM_ANSWER_ORDER_ID, label: 'Custom' },
];
